var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-window',{attrs:{"endpoint":"/reports/paxlist","fields":_vm.fields,"title":_vm.title,"headers":_vm.headers,"templates":_vm.templates,"perPage":"500"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }